export const costs = [
  'Hours of downtime chasing the wrong fault',
  'Expensive pumps, valves and cylinders replaced without finding the real cause',
  'Schematics you can’t read with confidence',
  'Safety risks from stored pressure, accumulators and hose failures',
];
